export default () => ({
  open: false,
  value: '',
  textValue: '',
  placeholder: '',
  options: [],
  init(){
    const selectElement = this.$el.querySelector('select')
    this.value = selectElement.value
    this.$watch('value', (newValue) => selectElement.value = newValue)
    this.options = Array.from(selectElement.options).map((el) => { return {value: el.value, text: el.innerText} })
    this.placeholder = selectElement.getAttribute('placeholder')
    this.textValue = selectElement.querySelector('option:checked')?.innerText
  },
  onSelect(el){
    this.value = el.dataset.value
    this.textValue = this.value ? el.innerText : this.placeholder

    this.$nextTick(() => {
      const selectElement = this.$root.querySelector('select')
      // trigger change for listeners
      selectElement.dispatchEvent(new Event('change'))
    })
  }
})